import * as types from "./UserActionType";


const initialState = {
    rolesList: [],
    userList: [],
    placeList: [],
    busStationList: [],
    corporationList: [],
    divisionList: [],
    countersFilter: [],
    depotList: [],
    BToBBToCUserList: [],
    userLevelList: [],
    userDepartmentsList: []
}
const UserReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.COUNTERS_FILTER:
            return {
                ...state,
                countersFilter: [...action.payload]
            }
        case types.ROLES_LIST:
            return {
                ...state,
                rolesList: [...action.payload]
            }
        case types.USER_LIST:
            return {
                ...state,
                userList: [...action.payload]
            }
        case types.PLACE_LIST:
            return {
                ...state,
                placeList: [...action.payload]
            }
        case types.BUSSTATION_LIST:
            return {
                ...state,
                busStationList: [...action.payload]
            }
        case types.CORPORATION_LIST:
            return {
                ...state,
                corporationList: [...action.payload]
            }
        case types.DIVISION_LIST:
            return {
                ...state,
                divisionList: [...action.payload]
            }
        case types.DEPOT_LIST:
            return {
                ...state,
                depotList: [...action.payload]
            }
        case types.BTOB_BTOC_USER_LIST:
            return {
                ...state,
                BToBBToCUserList: [...action.payload]
            }
        case types.UPDATE_USER_LEVEL:
            return {
                ...state,
                userLevelList: action.payload
            }
        case types.UPDATE_USER_DEPARTMENT:
            return {
                ...state,
                userDepartmentsList: action.payload
            }
        default:
            return state;
    }
}
export default UserReducer;